/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-kit-item.reducer';

export const PharmacyKitItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyKitItemEntity = useAppSelector(state => state.pharmacyKitItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyKitItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.detail.title">PharmacyKitItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitItemEntity.id}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitItemEntity.quantity}</dd>
          <dt>
            <span id="expectedQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.expectedQty">Expected Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitItemEntity.expectedQty}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitItemEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitItemEntity.lastupdated}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitItemEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyKitItemEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.kit">Kit</Translate>
          </dt>
          <dd>{pharmacyKitItemEntity.kit ? pharmacyKitItemEntity.kit.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.drugStock">Drug Stock</Translate>
          </dt>
          <dd>{pharmacyKitItemEntity.drugStock ? pharmacyKitItemEntity.drugStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.consumableStock">Consumable Stock</Translate>
          </dt>
          <dd>{pharmacyKitItemEntity.consumableStock ? pharmacyKitItemEntity.consumableStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.implantStock">Implant Stock</Translate>
          </dt>
          <dd>{pharmacyKitItemEntity.implantStock ? pharmacyKitItemEntity.implantStock.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-kit-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-kit-item/${pharmacyKitItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyKitItemDetail;
